import { ActionTypes } from 'redux/utils/Delete'

export default ActionTypes('DOCUMENT')